import { BrowserRouter, Route, Switch } from 'react-router-dom';

import './styles/global.scss';

import { Menu } from "./pages/Menu";
import { Login } from "./pages/Login";
import { Authentication } from "./pages/Authentication";
import { Attachments } from "./pages/Attachments";
import { RegisterCard } from "./pages/RegisterCard";
import { SignContract } from "./pages/SignContract";
import { EnableStreaming } from "./pages/EnableStreaming";
import { Profile } from "./pages/Profile";
import { Invoices } from './pages/Invoices';
import { Contract } from './pages/Contract';
import { Connection } from './pages/Connection';
import { Payment } from './pages/Payment';
import { SinglePayment } from './pages/SinglePayment';
import { Settings } from './pages/Settings';
import { NotFound } from './pages/NotFound';
import { Totem } from './pages/Totem';

import { AuthContextProvider } from './contexts/AuthenticationContext';

import { AlertContextProvider } from './contexts/AlertContext';
import AuthRoute from './components/AuthRoute/AuthRoute';
import Alert from "./components/Alert/Alert";
import {NotificationsContextProvider} from "./contexts/NotificationsContext";
import {Notifications} from "./pages/Notifications";

function App() {

	return (
		<BrowserRouter>
			<NotificationsContextProvider>
				<AuthContextProvider>
					<AlertContextProvider>
						<Alert/>
						<Switch>
							<Route path="/" exact component={Authentication}/>
							<Route path="/login" component={Login}/>
							<Route path="/autenticacao" component={Authentication}/>
							<Route path="/anexos/:token" component={Attachments}/>
							<Route path="/listar_informacoes/:token" component={RegisterCard}/>
							<Route path="/contrato/assinar/:token" exact component={SignContract}/>
							<Route path="/ativacao-streaming/:token" exact component={EnableStreaming}/>
							<Route path="/totem" exact component={Totem}/>
							<AuthRoute path="/menu" component={Menu}/>
							<AuthRoute path="/perfil" component={Profile}/>
							<AuthRoute path="/boletos" component={Invoices}/>
							<AuthRoute path="/contrato" exact component={Contract}/>
							<AuthRoute path="/conexao/:connectionId" component={Connection}/>
							<AuthRoute path="/pagamento/:paymentId" component={Payment}/>
							<AuthRoute path="/pagamento_avulso/:paymentId" exact component={SinglePayment}/>
							<AuthRoute path="/configuracoes" component={Settings}/>
							<AuthRoute path="/notificacoes" component={Notifications}/>
							<Route path="*" component={NotFound}/>
						</Switch>
					</AlertContextProvider>
				</AuthContextProvider>
			</NotificationsContextProvider>
		</BrowserRouter>
	);
}

export default App;
